export enum ProjectSemesterType {
	FIRST = "FIRST",
	SECOND = "SECOND",
	THIRD = "THIRD",
	OTHER = "OTHER",
	NONE = "NONE",

	DEFAULT = "DEFAULT"
}
